import {
    Link,
    Text
} from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import BreedSearch from "./BreedSearch";
import {
    QuotesDispatchContext,
    QuotesStateContext,
    getQuotes,
    ageLabel,
    ageBrackets
} from "../contexts/quotes";
import React, { useState, useContext } from 'react';

export default function PetBasicDetailsForQuote() {
    const { request } = useContext(QuotesStateContext);
    // Editable by default so a first-time visitor can enter age & breed straight away.
    // The pencil affordance re-opens edit mode after a selection locks the fields.
    const [disabled, setDisabled] = useState(false);
    const [age, setAge] = useState(request.age);
    const [breed_id, setBreed_id] = useState(request.breed_id);
    const [breed_label, setBreed_label] = useState(request.breed_label);
    const [breed_group, setBreed_group] = useState(request.breed_group);

    const dispatch = useContext(QuotesDispatchContext);

    function selectAge(event) {
        setDisabled(true)
        setAge(event?.target?.value);
        getQuotes(dispatch, { 'age': event?.target?.value, 'breed_id': breed_id, 'breed_label': breed_label, 'breed_group': breed_group });
    }


    function selectBreed(selected) {
        //console.log('selectBreed called :' + selected)
        if (selected) {
            if (selected[0]) {
                setDisabled(true)
                setBreed_id(selected[0].id);
                setBreed_label(selected[0].label);
                setBreed_group(selected[0].group);
                getQuotes(dispatch, { 'age': age, 'breed_id': selected[0].id, 'breed_label': selected[0].label, 'breed_group': selected[0].group });
            } else {
                // On clear / no selection, reset to empty and require a real
                // re-selection rather than silently substituting a default breed
                // (which would change the quoted premium without the user knowing).
                setBreed_id('');
                setBreed_label('');
                setBreed_group('');
            }

        }

    }

    const editPetDetails = () => {
        // Drive edit mode purely from React state; the disabled-select class is
        // now derived from `disabled` in the render below (no jQuery DOM poking).
        setDisabled(false);
    }

    return (
        <div className="wrapper-dog-details">
            <div className="container">
                <div className="row no-gutters">
                    <div className="col-md-11 col-10">
                        <div className="row no-gutters">
                            <div className="col-lg-6 dog-details">
                                <label htmlFor="pet-age-select"><strong>AGE : </strong></label>
                                <div className={"form-group custom-bgpet mb-0" + (disabled ? " disabled-select" : "")}>
                                    <select id="pet-age-select" aria-label="Pet age" value={age} className="custom-select" onChange={(event) => selectAge(event)} disabled={disabled}>
                                        <option disabled value="">Select Pet Age</option>
                                        {ageBrackets.map((bracket) => (
                                            <option key={bracket} value={bracket}>{ageLabel.get(bracket)}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-6 dog-details dog-breed-bg">
                                <label htmlFor="pet-breed-input"><strong>BREED : </strong></label>
                                <div className={"form-group custom-bgpet mb-0" + (disabled ? " disabled-select" : "")}>
                                    <BreedSearch disabled={disabled} ariaLabel="Pet breed" onChange={(selected) => selectBreed(selected)} defaultInputValue={breed_label} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-1 col-2 edit-details-bg">
                        <Link href="#" className="editPetDetails" onClick={editPetDetails}><i className="icon-edit"></i></Link>
                    </div>
                </div>
                <div className="row no-gutters">
                <Text variation={'tertiary'} fontSize={'0.7rem'} as='p'>The options suggested herein are just out of permutation of various coverages under Digit Pet Insurance Policy UIN: IRDAN158RP0006V01202223 for customer convenience. For more details, please read and refer to policy terms and conditions carefully before enrollement.Note: Apart from the option chosen, your pet insurance premium will be calculated based on your dog’s age and breed.</Text>
                </div>
            </div>

        </div>
    );

}